module.exports = __webpack_public_path__ + "media/iconic/envelope-e4cacd46.svg";